module.exports = "/static-assets/_next/static/images/ugc-texture-7e6f89d4ebc6cd6916ca062079bbd7ca.png";